module.exports = __webpack_public_path__ + "img/product-17.d6c87f6c.jpg";